import { useEffect } from 'react';

const useHideScrollBar = (active = true) => {
  useEffect(
    () => {
      document.querySelector(
        'body',
      ).style.overflow = active ? 'hidden' : 'auto';
      return () => { document.querySelector('body').style.overflow = 'auto'; };
    },
    [active],
  );
};

export default useHideScrollBar;
